<template>
  <f7-popup id="popup-lesson-history">
    <f7-view>
      <f7-page>
        <!-- <f7-block-title large>History</f7-block-title> -->
        <f7-navbar title="History"></f7-navbar>

        <span v-if="!history.length" class="chat-empty-message">
          No Consultations
        </span>

        <f7-list v-else media-list>
          <f7-list-item
            v-for="lesson in history"
            :key="lesson.lessonId"
            :link="`/history-preview/${lesson.lessonId}`"
            :route-props="{ messages: lesson.messages }"
          >
            <div slot="title">
              <span style="color: #87919c; font-weight: 400;">Consultation name:</span>
              {{ lesson.name || '-' }}
            </div>
            <div slot="subtitle">
              {{ `Date: ${format(new Date(lesson.start), 'dd-MM-yyyy')}` }}
            </div>
          </f7-list-item>
        </f7-list>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import { format } from 'date-fns';
import apiRequest from '../js/helpers/apiRequest.js';

export default {
  name: 'PopupHistory',

  data() {
    return {
      history: []
    };
  },

  computed: {
    format: () => format
  },

  created() {
    this.getHistoryList();
  },

  methods: {
    async getHistoryList() {
      try {
        const id = this.$f7route.params.id;
        const res = await apiRequest(`lessons/history/${id}`, 'GET', null, true);

        if (res.success) {
          const history = res.success.map(
            ({ id, status, name, teacher_id, start, end, messages }) => ({
              lessonId: id,
              teacherId: teacher_id,
              status,
              name,
              start,
              end,
              messages: messages.map(
                ({
                  id,
                  mark,
                  quote,
                  quote_date,
                  lesson_id,
                  created_at,
                  user_id,
                  text,
                  attachments
                }) => ({
                  id,
                  lessonId: lesson_id,
                  type: user_id === teacher_id ? 'received' : 'sent',
                  mark,
                  quote,
                  quoteDate: quote_date,
                  date: created_at,
                  userId: user_id,
                  text,
                  attachment:
                    attachments && attachments.length
                      ? {
                          src: attachments[0].src,
                          name: attachments[0].name,
                          type: attachments[0].type,
                          size: attachments[0].size
                        }
                      : null
                })
              )
            })
          );

          this.history = history;
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss">
#popup-lesson-history.popup:not(.popup-tablet-fullscreen) {
  @media (min-height: 630px) and (min-width: 630px) {
    --f7-popup-tablet-width: 500px;
    --f7-popup-tablet-height: 500px;
  }
}
</style>
